import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { api } from '../../services/api'
import { assignKennels, saveArea, saveStaff, reloadFacilities } from '../../actions/facilities/facilities.actions'
import TableDropdown from '../../components/Tables/TableDropdown'
import { getVisitsByFacilityId } from '../../actions/visits/visits.actions'
import { Calendar, Views, momentLocalizer } from 'react-big-calendar'
const localizer = momentLocalizer(moment)
import CloseArea from '../../components/Dialogs/CloseAreaDialog'

import { PlayAreaDialog, StaffDialog } from '../../components/Dialogs'
import KennelBlockDialogNew from '../../components/Dialogs/KennelBlockDialogNew'
import { PlaygroupsTable } from '../../components/Tables/PlaygroupsTable'
import { STATUS_ID } from '../../utils'
import Loading from '../common/Loading'
import LoadingOverlay from '../../components/Misc/LoadingOverlay'
import { MenuItem, Typography } from '@material-ui/core'
import { PlayYardScheduleToolbar } from '../../components/Tables/Toolbars/PlayYardSchedule/PlayYardScheduleToolbar'

import { gray, purple } from '../../utils/colors'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		paddingTop: '24px',
		paddingLeft: '25px',
		paddingRight: '20px',
		paddingBottom: '75px',
		'& .rbc-calendar': {
			'& .rbc-time-gutter': {
				display: 'none'
			},
			'& .rbc-time-view': {
				backgroundColor: 'white',
				'& .rbc-time-header-gutter': {
					width: '5.25rem !important',
					minWidth: '5.25rem !important',
					maxWidth: '5.25rem !important'
				},

				'& .rbc-time-column': {
					border: 'none',
					borderRadius: '0'
				},

				'& .rbc-time-gutter': {
					width: '0px !important'
				},
				'& .rbc-allday-cell': {
					display: 'none'
				}
			},
			'& .rbc-today': {
				backgroundColor: 'white'
			}
		}
	},
	rootInt: {
		width: 300,
		'& .rbc-calendar': {
			'& .rbc-time-gutter': {
				display: 'flex'
			},
			'& .rbc-time-view': {
				backgroundColor: 'white',
				'& .rbc-time-header-gutter': {
					width: '5.25rem !important',
					minWidth: '5.25rem !important',
					maxWidth: '5.25rem !important'
				},

				'& .rbc-time-column': {
					border: 'none',
					borderRadius: '0'
				},

				// '& .rbc-time-gutter': {
				// 	width: '150px !important',
				// },
				'& .rbc-allday-cell': {
					display: 'none'
				}
			},
			'& .rbc-today': {
				backgroundColor: 'white'
			}
		}
	}
}))

const PlayYardSchedule = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()

	const facility = useSelector((state) => state.specific.facilities.selected)
	const loading = useSelector((state) => state.specific.facilities.loading)
	const staff = useSelector((state) => state.specific.facilities.staff)
	const visits = useSelector((state) => state.specific.visits.visits)
	const pets = useSelector((state) => state.specific.visits.pets)
	const [selectedPlaygroup, selectPlaygroup] = useState(null)
	const [date, setDate] = useState(moment().format('YYYY-MM-DD'))
	const [kbShown, setKbShown] = useState(false)
	const [dialog, setDialog] = useState(false)
	const [openMenus, setOpenMenus] = useState([])
	const [schedule, setSchedule] = useState([])
	const [specialKey, setSpecialKey] = useState(0)
	const [closeAreaDialog, setCloseAreaDialog] = useState(false)
	const [area, setArea] = useState(null)
	const [event, setEvent] = useState(null)

	const [playAreaShown, setPlayShown] = useState(null)

	const setNewDate = (date) => {
		setDate(date)
	}

	const clone = moment(date).format('YYYY-MM-DD')
	const min = moment(`${clone} 09:00`, 'YYYY-MM-DD HH:mm').toDate()
	const max = moment(`${clone} 22:00`, 'YYYY-MM-DD HH:mm').toDate()

	const changeDate = (type) => {
		if (type === 'add') {
			setDate(moment(date).add(1, 'd').format('YYYY-MM-DD'))
		} else if (type === 'subtract') {
			setDate(moment(date).subtract(1, 'd').format('YYYY-MM-DD'))
		}
	}

	useEffect(() => {
		if (facility) {
			dispatch(getVisitsByFacilityId(facility, date))
			getPlayYardSchedule()
		}
	}, [date, facility])

	const setIsShown = (shown, group) => {
		setDialog(shown)
		selectPlaygroup(group)
	}

	useEffect(() => {
		dispatch(reloadFacilities(false))
	}, [])

	const getPlayYardSchedule = async () => {
		const { data } = await api.get(`/facilities/playSchedule?facilityId=${facility._id}&date=${date}`)

		setSchedule(data)

		setSpecialKey(JSON.stringify(data))
	}

	const assignYards = async () => {
		await api.post(`/facilities/playSchedule?facilityId=${facility._id}&date=${date}`)

		getPlayYardSchedule()
	}

	const areaArray = useMemo(() => {
		return schedule.map((area) => {
			const disabled = area.disabled ? true : false

			if (disabled) {
				return {
					...area,
					disabled: true,
					start: moment('09:00', 'HH:mm').toDate(),
					end: moment('19:00', 'HH:mm').toDate(),
					title: `${area.name} - Closed`,
					allDay: false,
					background: true,
					events: []
				}
			}

			const events = area.events.map((event) => {
				return {
					start: moment(event.start_time, 'HH:mm').toDate(),
					buffer: event.buffer,
					end: moment(event.end_time, 'HH:mm').subtract(event.buffer, 'minutes').toDate(),
					title: event.manual ? 'Area Closed' : event.group_name,
					allDay: false,
					backgroundColor: area.color,
					borderColor: area.color,
					area_id: area._id,
					event_id: event._id,
					manual: event.manual ? true : false
				}
			})

			const mappedEvents = [...events]

			events.forEach((e) => {
				let startBuffer = {
					start: moment(e.start).subtract(e.buffer, 'minutes').toDate(),
					end: e.start,
					backgroundColor: 'gray',
					area_id: area._id,
					event_id: e._id,
					isBuffer: true
				}

				// mappedEvents.push(startBuffer)

				let endBuffer = {
					start: e.end,
					end: moment(e.end).add(e.buffer, 'minutes').toDate(),
					backgroundColor: 'gray',
					area_id: area._id,
					event_id: e._id,
					isBuffer: true
				}

				mappedEvents.push(endBuffer)
			})

			return {
				...area,
				start: moment('09:00', 'HH:mm').toDate(),
				end: moment('19:00', 'HH:mm').toDate(),
				title: `${area.name} ${area.type === 'Indoor Play' ? '(Indoor)' : '(Outdoor)'}`,
				allDay: false,
				background: true,
				events: mappedEvents

				// backgroundColor: area.color,
				// borderColor: area.color
			}
		})
	}, [schedule])

	const components = useMemo(() => {
		return {
			timeGutterHeader: () => <div></div>
		}
	}, [])

	const closeArea = async (body) => {
		try {
			await api.post(
				`/facilities/closeArea?facilityId=${facility._id}&areaId=${
					area._id
				}&date=${date}&open=${!area.disabled}`,
				body
			)

			const hasEvents = area.events.length > 0

			if (body._id) {
				setCloseAreaDialog(false)
				setArea(null)
				setEvent(null)

				const allEvents = []

				schedule.forEach((s) => {
					allEvents.push(...s.events)
				})

				const mappedEvents = allEvents.map((e) => {
					if (e._id == body._id) {
						return {
							...e,
							start_time: body.start_time,
							end_time: body.end_time,
							area_id: body.area_id
						}
					}

					return e
				})

				const newSchedule = schedule.map((a) => {
					return {
						...a,
						events: mappedEvents.filter((e) => e.area_id == a._id)
					}
				})

				setSchedule(newSchedule)

				return
			}

			if (hasEvents) {
				assignYards()
			} else {
				getPlayYardSchedule()
			}
			setCloseAreaDialog(false)
			setArea(null)
			setEvent(null)
		} catch (e) {
			console.log(e)
		}
	}

	const selectEvent = (e) => {
		if (e.background || e.isBuffer) return

		const ar = areaArray.find((a) => a._id === e.area_id)
		setArea(ar)
		setEvent(e)
		setCloseAreaDialog(true)
	}

	const formats = useMemo(
		() => ({
			eventTimeRangeFormat: (e) => {
				console.log('what?', e)
			}
		}),
		[]
	)

	return (
		<div className={classes.root}>
			<PlayYardScheduleToolbar
				selectedFacility={facility || {}}
				assignYards={assignYards}
				changeDate={setNewDate}
				date={date}
			/>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'flex-start',
					width: '100%',
					overflowY: 'scroll'
					// border: '1px solid #e0e0e0',
				}}>
				{/*<div className={classes.rootInt}>
					<Calendar
						dayLayoutAlgorithm="no-overlap"
						components={components}
						key={specialKey}
						localizer={localizer}
						events={timeBlocks}
						defaultDate={date}
						time_zone={facility?.time_zone || 'America/New_York'}
						defaultView={Views.DAY}
						backgroundEvents={[]}

						scrollToTime={false}
						getNow={() => null}
						min={min}
						max={max}
						toolbar={false}
						views={['day']}
						style={{ width: 100 }}
						startAccessor="start"
						endAccessor="end"

					/>
				</div>*/}
				{areaArray.map((area) => {
					return (
						<div style={{ width: 300, marginRight: 16 }}>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'space-between',
									alignItems: 'center',
									width: '100%'
								}}>
								<Typography variant="h6" style={{ fontWeight: 'bold', fontSize: 16 }}>
									{area.title}
								</Typography>
								<TableDropdown>
									<MenuItem
										onClick={() => {
											setArea(area)
											setEvent(null)
											setCloseAreaDialog(true)
										}}>
										{area.disabled ? 'Open Area' : 'Close Area'}
									</MenuItem>
								</TableDropdown>
							</div>

							<Calendar
								dayLayoutAlgorithm="no-overlap"
								components={components}
								key={specialKey}
								localizer={localizer}
								events={area.events}
								defaultDate={date}
								time_zone={facility?.time_zone || 'America/New_York'}
								defaultView={Views.DAY}
								backgroundEvents={[area]}
								eventPropGetter={(event) => {
									// console.log('event', event)

									if (event.isBuffer) {
										return {
											style: {
												backgroundColor: gray[300],
												// color: gray[300],
												color: '#1a1a35',
												border: 'none'
											}
										}
									}

									if (event.disabled || event.manual) {
										return {
											style: {
												backgroundColor: gray[500],
												color: '#1a1a35',
												border: 'none'
											}
										}
									}

									return {
										style: {
											backgroundColor: event.background ? '#FFFFFF' : purple[100],
											color: event.background ? '#FFFFFF' : '#1a1a35',
											border: event.background ? 'none' : '1px solid #e0e0e0'
										}
									}
								}}
								dayPropGetter={(date) => {
									return {
										style: {
											backgroundColor: '#FFFFFF',
											border: 'none'
										}
									}
								}}
								scrollToTime={false}
								getNow={() => null}
								min={min}
								max={max}
								onSelectEvent={selectEvent}
								toolbar={false}
								views={['day']}
								style={{ width: 300, height: 2000 }}
								startAccessor="start"
								endAccessor="end"
							/>
						</div>
					)
				})}
			</div>
			<CloseArea
				isShown={closeAreaDialog}
				setIsShown={setCloseAreaDialog}
				onConfirmDelete={closeArea}
				areas={schedule}
				facility={facility}
				area={area}
				event={event}
				date={date}
			/>
		</div>
	)
}

export default PlayYardSchedule
